import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./css/Header.css";

const Header = ({ setSearchQuery, isLoggedIn, handleLogout }) => {
  const [menuActive, setMenuActive] = useState(false);
  const [progress, setProgress] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  const [showScrollTop, setShowScrollTop] = useState(false);
  const [supplyChainSubmenu, setSupplyChainSubmenu] = useState(false);

  const userRole = sessionStorage.getItem("role");

  const headerlogoImages = [{ src: "/images/site-logo.png" }];

  const toggleMenu = () => {
    setMenuActive(!menuActive);
  };

  useEffect(() => {
    setMenuActive(false);
    setProgress(0);

    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "instant" });
    }, 0);
  }, [location.key]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      const scrollPosition = window.scrollY;
      const scrollPercentage = (scrollPosition / scrollHeight) * 100;
      setProgress(scrollPercentage);
      setShowScrollTop(scrollPosition > 200);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleMenuItemClick = () => {
    setMenuActive(false);
    setSupplyChainSubmenu(false);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <header className="site-header">
      <div className="inner-content">
        <div className="bottom-bar">
          <div className="container">
            <div className="listing-header">
              {headerlogoImages.map((image, index) => (
                <div className="site-logo" key={index}>
                  <Link to="/">
                    <img src={image.src} alt="Site Logo" />
                  </Link>
                </div>
              ))}

              <div className="site-nav">
                <div className="menu-toggle" onClick={toggleMenu}>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>

                <div className={`site-menu ${menuActive ? "active" : ""}`}>
                  <ul className="main-list">
                    <li>
                      <Link
                        to="/"
                        className={
                          location.pathname === "/" ? "active-link" : ""
                        }
                        onClick={handleMenuItemClick}
                      >
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/employee-attendance"
                        className={
                          location.pathname === "/employee-attendance"
                            ? "active-link"
                            : ""
                        }
                        onClick={handleMenuItemClick}
                      >
                        Attendance
                      </Link>
                    </li>

                    <li
                      className={`has-submenu ${
                        supplyChainSubmenu ? "submenu-active" : ""
                      }`}
                    >
                      <span
                        onClick={() =>
                          setSupplyChainSubmenu(!supplyChainSubmenu)
                        }
                      >
                        Supply Chain &nbsp;
                        {supplyChainSubmenu ? (
                          <i className="fa-solid fa-caret-up"></i>
                        ) : (
                          <i className="fa-solid fa-caret-down"></i>
                        )}
                      </span>
                      <ul className="submenu">
                        <li>
                          <Link
                            to="/distributor-verification"
                            className={
                              location.pathname === "/distributor-verification"
                                ? "active-link"
                                : ""
                            }
                            onClick={handleMenuItemClick}
                          >
                            Distributor
                          </Link>
                        </li>
                      </ul>
                    </li>

                    <li>
                      <Link
                        to="/meeting"
                        className={
                          location.pathname === "/meeting" ? "active-link" : ""
                        }
                        onClick={handleMenuItemClick}
                      >
                        Meeting
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/my-order"
                        className={
                          location.pathname === "/my-order" ? "active-link" : ""
                        }
                        onClick={handleMenuItemClick}
                      >
                        My Order
                      </Link>
                    </li>
                    
                    <li>
                      <div className="hire-btn">
                        <button
                          onClick={
                            isLoggedIn ? handleLogout : () => navigate("/login")
                          }
                        >
                          {isLoggedIn ? "Logout" : "Login"}
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="progress-container">
        <div className="progress-bar" style={{ width: `${progress}%` }}></div>
      </div>

      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="scroll-to-top-btn bounce-animation"
        >
          <i className="fa-solid fa-arrow-up"></i>
        </button>
      )}
    </header>
  );
};

export default Header;
